import { InsuranceInformation, InsuranceInformationBaseStore } from "@roc/feature-insurance-review";

export type InsuranceInformationInternalProps = {
  store: InsuranceInformationBaseStore,
  loanId: string,
  taskId: string,
};

export const InsuranceInformationInternal = (props: InsuranceInformationInternalProps) => {
  const { store, loanId, taskId } = props;
  return (
    <InsuranceInformation
      store={store}
      loanId={loanId}
      taskId={taskId}
      handleClose={() => window.parent.postMessage('saved-success', '*')}
    />
  )
}